import { useEffect, useState } from "react";
import { getRadonByPostinumero } from "../../../api/api";
import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const GREEN = "#04aa00";
const LIGHT_GREY = "#f0f0f0";
const WHITE = "#ffffff";

export default function YmparistoBlock() {
  const { rakennusData: kiinteisto } = useReportTemplateContext();

  const rakennukset =
    kiinteisto?.rakennukset_fulls ||
    kiinteisto?.rakennukset ||
    [];

  const getRakennusLabel = rakennus =>
    rakennus.rakennustunnus ||
    rakennus.Rakennustunnus ||
    rakennus.id_rakennus ||
    "Rakennus";

  const postinumero =
    rakennukset?.[0]?.postinumero ||
    kiinteisto?.postinumero ||
    null;

  const [radonData, setRadonData] = useState(null);
  const [hiddenRadonRows] = useState([]);

  useEffect(() => {
    if (!postinumero) {
      setRadonData(null);
      return;
    }

    let isMounted = true;

    const fetchRadon = async () => {
      try {
        const response = await getRadonByPostinumero(postinumero);

       if (isMounted) {
  setRadonData(response.data?.postinumero || null);
}
      } catch (error) {
        if (isMounted) {
          setRadonData(null);
        }
      }
    };

    fetchRadon();

    return () => {
      isMounted = false;
    };
  }, [postinumero]);

  const RADON_ROWS = [
    {
      key: "Postinumero",
      label: "Postinumero",
      value: radonData?.Postinumero
    },
    {
      key: "Postitoimipaikka",
      label: "Postitoimipaikka",
      value: radonData?.Postitoimipaikka
    },
    {
      key: "mitattuja",
      label: "Mitattuja pientaloasuntoja",
      value: radonData?.["Mitattuja pientaloasuntoja"]
    },
    {
      key: "Mediaani",
      label: "Mediaani (Bq/m³)",
      value: radonData?.["Mediaani  Bq/m3"]
    },
    {
      key: "Keskiarvo",
      label: "Keskimääräinen radon (Bq/m³)",
      value: radonData?.["Keskiarvo Bq/m3"]
    },
    {
      key: "200",
      label: "200 Bq/m³ ylitykset (%)",
      value: radonData?.["200 Bq/m3 ylitykset %"]
    },
    {
      key: "300",
      label: "300 Bq/m³ ylitykset (%)",
      value: radonData?.["300 Bq/m3 ylitykset %"]
    },
    {
      key: "1000",
      label: "1000 Bq/m³ ylitykset (%)",
      value: radonData?.["1000 Bq/m3 ylitykset %"]
    }
  ];

  const renderValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  return (
    <div
      className="rounded border overflow-hidden"
      style={{
        backgroundColor: WHITE,
        borderColor: "#e9f0ec"
      }}
    >
      {/* Pohjavesi- ja tulvariskialueet */}
      <section>
        <div
          className="px-3 py-2 fw-bold text-white"
          style={{ backgroundColor: GREEN }}
        >
          Pohjavesi- ja tulvariskialueet
        </div>

        {rakennukset.length === 0 ? (
          <div className="p-3 text-muted">
            Ei ympäristötietoja saatavilla.
          </div>
        ) : (
          rakennukset.map((rakennus, rakennusIndex) => {
            const pohjavesialueet =
              rakennus.aluetiedot?.pohjavesi || [];

            const tulvariskialueet =
              rakennus.aluetiedot?.tulvariski || [];

            return (
              <div
                key={
                  rakennus.id_rakennus ||
                  rakennus.rakennustunnus ||
                  rakennusIndex
                }
              >
                {rakennukset.length > 1 && (
                  <div
                    className="px-3 py-2 fw-bold"
                    style={{
                      backgroundColor: "#e2e2e2"
                    }}
                  >
                    Rakennus: {getRakennusLabel(rakennus)}
                  </div>
                )}

                <table className="table table-sm mb-0">
                  <tbody>
                    <tr>
                      <th
                        colSpan={2}
                        className="px-3 py-2"
                        style={{
                          backgroundColor: LIGHT_GREY,
                          border: 0
                        }}
                      >
                        Pohjavesialueet
                      </th>
                    </tr>

                    {pohjavesialueet.length > 0 ? (
                      pohjavesialueet.flatMap(
                        (pohjavesi, pohjavesiIndex) => {
                          const rows = [];

                          if (pohjavesialueet.length > 1) {
                            rows.push(
                              <tr
                                key={`pohjavesi-title-${pohjavesiIndex}`}
                              >
                                <th
                                  colSpan={2}
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: "#fafafa",
                                    border: 0
                                  }}
                                >
                                  Pohjavesialue {pohjavesiIndex + 1}
                                </th>
                              </tr>
                            );
                          }

                          rows.push(
                            <tr
                              key={`pohjavesi-name-${pohjavesiIndex}`}
                            >
                              <th
                                className="px-3 py-2 fw-normal"
                                style={{
                                  width: "42%",
                                  backgroundColor: WHITE,
                                  border: 0
                                }}
                              >
                                Nimi
                              </th>

                              <td
                                className="px-3 py-2"
                                style={{
                                  backgroundColor: WHITE,
                                  border: 0
                                }}
                              >
                                {renderValue(pohjavesi.nimi)}
                              </td>
                            </tr>
                          );

                          if (pohjavesi.luokka) {
                            rows.push(
                              <tr
                                key={`pohjavesi-class-${pohjavesiIndex}`}
                              >
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  Luokka
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  {pohjavesi.luokka}
                                </td>
                              </tr>
                            );
                          }

                          if (pohjavesi.etäisyys) {
                            rows.push(
                              <tr
                                key={`pohjavesi-distance-${pohjavesiIndex}`}
                              >
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  Etäisyys
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  {pohjavesi.etäisyys}
                                </td>
                              </tr>
                            );
                          }

                          return rows;
                        }
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={2}
                          className="px-3 py-2"
                          style={{
                            backgroundColor: WHITE,
                            border: 0
                          }}
                        >
                          Kohde ei sijaitse pohjavesialueella.
                        </td>
                      </tr>
                    )}

                    <tr>
                      <th
                        colSpan={2}
                        className="px-3 py-2"
                        style={{
                          backgroundColor: LIGHT_GREY,
                          border: 0
                        }}
                      >
                        Tulvariskialueet
                      </th>
                    </tr>

                    {tulvariskialueet.length > 0 ? (
                      tulvariskialueet.flatMap(
                        (tulvariski, tulvaIndex) => {
                          const rows = [];

                          if (tulvariskialueet.length > 1) {
                            rows.push(
                              <tr key={`tulva-title-${tulvaIndex}`}>
                                <th
                                  colSpan={2}
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: "#fafafa",
                                    border: 0
                                  }}
                                >
                                  Tulvariskialue {tulvaIndex + 1}
                                </th>
                              </tr>
                            );
                          }

                          rows.push(
                            <tr key={`tulva-name-${tulvaIndex}`}>
                              <th
                                className="px-3 py-2 fw-normal"
                                style={{
                                  width: "42%",
                                  backgroundColor: WHITE,
                                  border: 0
                                }}
                              >
                                Nimi
                              </th>

                              <td
                                className="px-3 py-2"
                                style={{
                                  backgroundColor: WHITE,
                                  border: 0
                                }}
                              >
                                {renderValue(tulvariski.nimi)}
                              </td>
                            </tr>
                          );

                          if (tulvariski.lähde) {
                            rows.push(
                              <tr key={`tulva-source-${tulvaIndex}`}>
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  Lähde
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  {tulvariski.lähde}
                                </td>
                              </tr>
                            );
                          }

                          if (tulvariski.etäisyys) {
                            rows.push(
                              <tr key={`tulva-distance-${tulvaIndex}`}>
                                <th
                                  className="px-3 py-2 fw-normal"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  Etäisyys
                                </th>

                                <td
                                  className="px-3 py-2"
                                  style={{
                                    backgroundColor: WHITE,
                                    border: 0
                                  }}
                                >
                                  {tulvariski.etäisyys}
                                </td>
                              </tr>
                            );
                          }

                          return rows;
                        }
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={2}
                          className="px-3 py-2"
                          style={{
                            backgroundColor: WHITE,
                            border: 0
                          }}
                        >
                          Kohde ei sijaitse tulvariskialueella.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {rakennusIndex < rakennukset.length - 1 && (
                  <div
                    style={{
                      height: 1,
                      backgroundColor: "#dddddd"
                    }}
                  />
                )}
              </div>
            );
          })
        )}
      </section>

      {/* Radon */}
      <section className="mt-3">
        <div
          className="px-3 py-2 fw-bold text-white"
          style={{ backgroundColor: GREEN }}
        >
          Radon
        </div>

        {radonData ? (
          <table className="table table-sm mb-0">
            <tbody>
              {RADON_ROWS
                .filter(
                  row => !hiddenRadonRows.includes(row.key)
                )
                .map((row, index) => {
                  const rowBackground =
                    index % 2 === 0
                      ? LIGHT_GREY
                      : WHITE;

                  return (
                    <tr key={row.key}>
                      <th
                        className="px-3 py-2 fw-normal"
                        style={{
                          width: "42%",
                          backgroundColor: rowBackground,
                          border: 0
                        }}
                      >
                        {row.label}
                      </th>

                      <td
                        className="px-3 py-2"
                        style={{
                          backgroundColor: rowBackground,
                          border: 0
                        }}
                      >
                        {renderValue(row.value)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          <div
            className="px-3 py-2 text-muted"
            style={{ backgroundColor: WHITE }}
          >
            Ei radondataa postinumerolle{" "}
            {postinumero || "–"}.
          </div>
        )}
      </section>
    </div>
  );
}